import { useUBL } from '@common/log-manager';
import {
  getServerLogForVerticalProductCard,
  UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem,
} from '@common/product-card';
import { getUrl, usePdpConfig } from '@domains/pdp-common';

import { convertRecommendType } from './useRecommendTabLog';

interface ProductCardItemConfig extends UxGoodsCardItem {
  mainTitle?: string;
  groupType: string;
  position: number;
}

export const useBottomRecommendListLog = (originalProductId: string) => {
  const sendUBL = useUBL();
  const { isZigzagApp } = usePdpConfig();

  const convertLog = (item: ProductCardItemConfig) => {
    return isZigzagApp
      ? {
          navigation: 'product_detail',
          object_section: item.groupType,
          object_idx: item.position,
          object_id: item.catalog_product_id || '',
          data: {
            main_title: item.mainTitle && item.mainTitle.indexOf('BEST') > -1 ? '카테고리 BEST' : item.mainTitle,
            original_product_id: originalProductId,
            server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
          },
        }
      : {
          navigation: 'product_detail',
          navigation_sub: {
            page_url: getUrl(),
          },
          object_section: item.groupType,
          object_idx: item.position,
          object_id: item.catalog_product_id || '',
          data: {
            recommend_type: convertRecommendType(item.groupType),
            original_product_id: originalProductId,
            server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
          },
        };
  };

  const impressionProductItem = (item: ProductCardItemConfig) =>
    sendUBL({
      ...convertLog(item),
      category: 'impression',
      object_type: 'catalog',
    });

  const clickProductItem = (item: ProductCardItemConfig) =>
    sendUBL({
      ...convertLog(item),
      category: 'click',
      object_type: 'catalog',
    });

  const savedProduct = ({
    category,
    position,
    groupType,
    item,
  }: {
    category: 'save_product' | 'remove_saved_product';
    position: number;
    groupType: string;
    item: UxGoodsCardItem;
  }) => {
    sendUBL({
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: groupType,
      category,
      object_type: 'catalog',
      object_id: item.catalog_product_id || '',
      object_idx: position,
      data: {
        recommend_type: convertRecommendType(groupType),
        original_product_id: originalProductId,
        server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
      },
    });
  };

  const moreView = () =>
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'subtab_recommendation',
      object_type: 'button',
      object_id: 'see_more_item',
    });

  const clickSelectedMoreViewUBL = () =>
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'selected_recommend',
      object_type: 'button',
      object_id: 'see_more_item',
      data: {
        catalog_product_id: originalProductId,
      },
    });

  return {
    impressionProductItem,
    clickProductItem,
    savedProduct,
    moreView,
    clickSelectedMoreViewUBL,
  };
};
